import loadTranslations from './load-translations';
import setLocaLe from './set-locale';

export default {
  loadTranslations,
  setLocaLe,
};
